import api from 'plugin/api';
import { API_URL } from 'types/const';

/**
 * 제품 생산량 추이 조회
 * @param {Object} params 요청 데이터
 * @param {string} params.startProdYm 시작 월
 * @param {string} params.endProdYm 끝 월
 * @param {string} params.buCode BU
 * @param {number[]} params.factoryCodeSeqList 공장
 * @return {Object} 응답 데이터
 */
async function requestTrend(params) {
  return api.get(API_URL.sfms.dashboard.product.output.trend, { params });
}

export { requestTrend };
